import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL =
    // window.location?.hostname?.includes('localhost')
    // 'http://localhost:5003'
    'https://vare-middleware.herokuapp.com'


export const socket = io(URL);